<template>
  <div class="agree-content terms">
    <br/>
    <p>
      <strong>지피테라퓨틱스코리아 주식회사 (ZP Therapeutics Korea Co., Ltd.) 귀중</strong><br /><br />
      본인은 아래의 내용을 확인하고, 지피테라퓨틱스코리아 주식회사 (이하 &quot;회사&quot;라고 합니다)가
      다음과 같이 본인의 개인정보를 처리(수집, 이용, 제공 등)하는 것과 회사의 마케팅 정보의
      수신에 동의합니다.
    </p>
    <table>
      <tr>
        <td colspan="3">
          · 개인정보의 수집 및 이용
        </td>
      </tr>
      <tr>
        <th style="width: 20%;">수집항목</th>
        <td style="width: 20%; vertical-align: top;">필수항목</td>
        <td>성명, 소속 기관명(약국,병원명), 진료과, 병원,약국 주소, 휴대전화번호, 이메일주소, 네트워크 이용 기록</td>
      </tr>
      <tr>
        <th>수집 및 이용목적</th>
        <td colspan="2">
          · 이용자본인 확인, 이용자 식별, 회원탈퇴 의사의 확인 등 회원관리<br />
          · 고객 관계 설정 및 유지<br />
          · 이벤트 정보 및 참여기회 제공, 제품설명회 등 광고성 정보 제공 등 마케팅
        </td>
      </tr>
      <tr>
        <th>보유 및 이용기간</th>
        <td colspan="2">
          <u style="text-decoration-color: var(--v-info-lighten4);">귀하의 개인정보는 원칙적으로 개인정보의 수집 및 이용 목적이 달성되면
          지체없이 파기합니다. 다만 회사는 관계 법령의 규정에 따라 귀하의
          개인정보를 보존할 필요가 있는 경우에 관계법령에서 정한 일정 기간 동안
          귀하의 개인정보를 보관할 수 있습니다.</u>
          <table border="1">
            <tr>
              <th style="width: 50%; text-align: center;">보존항목</th>
              <th style="text-align: center;">근거법령</th>
              <th style="width: 25%; text-align: center;">보존기간</th>
            </tr>
            <tr>
              <td>
                계약 또는 청약철회 등에 관한 기록
              </td>
              <td rowspan="4">
                전자상거래 등에서의 소비자 보호에 관한 법률
              </td>
              <td>5년</td>
            </tr>
            <tr>
              <td>
                대금결제 및 재화 등의 공급에 관한 기록
              </td>
              <td>5년</td>
            </tr>
            <tr>
              <td>
                소비자의 불만 또는 분쟁처리에 관한 기록
              </td>
              <td>3년</td>
            </tr>
            <tr>
              <td>
                표시/광고에 관한 기록
              </td>
              <td>6개월</td>
            </tr>
            <tr>
              <td>
                접속로그, 접속IP정보, 서비스이용기록
              </td>
              <td>
                통신비밀보호법
              </td>
              <td>3개월</td>
            </tr>
          </table>
        </td>
      </tr>
    </table>

    <p>
      귀하는 위와 같은 개인정보의 수집 및 이용을 거부할 수 있습니다.
      다만, 개인정보의 필수적 수집 및 이용에 동의하지 않을 경우 회사와의 거래관계 설정 및 유지가
      불가능 할 수 있습니다.
      <br/>
      본인은 회사의 일반 개인정보 수집 및 이용에 관한 설명을 모두 이해하였고 이에 동의합니다.
    </p>
    <br/>
  </div>
</template>

<script>
export default {};
</script>

